<template>
  <!-- 分享成功显示弹窗 -->
  <div class="shareBack" v-if="show" >
    <div class="content">
      <div class="close" @click="close"></div>
      <p class="title">分享成功</p>
      <div class="img"><img src="../images/shareHeader.png" alt=""></div>
      <p class="h1">感谢您，平台有更多优质文章值得分享</p>
      <div class="data" v-if="content.id||''">
        <div class="dataImg"><img :src="content.imageAddr" alt=""></div>
        <div class="text">
          <p class="p1">{{content.title}}</p>
          <a :href="content.detailURL" @click="close"><div class="button">立即查看</div></a>          
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import global from "../js/global.js"
export default {
  data () {
    return {
        popShow:false,
    }
  },
  props:['show','content'],
  methods:{
    close(){
      this.$parent.closeTip();
    }
  }
}
</script>
<style lang="less" scoped>
.shareBack{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(4,4,15,0.6);
    z-index: 999;
    .content{
      position: absolute;
      top:50%;
      left: 50%;
      margin: -360px 0 0 -300px;
      width: 600px;
      height: 720px;
      background-color: #fff;
      background: url('../images/shareBack.png') no-repeat;
      background-size: 100% 100%;
      .close{
        position: absolute;
        top:30px;
        right: 30px;
        width: 40px;
        height: 40px;
        background: url('../images/sharebackclose.png') no-repeat;
        background-size: 100% 100%;
      }
      .title{
        margin: 96px 0 42px 0;
        font-size: 40px;
        color: #EF4B4B;
        text-align: center;
      }
      .img{
        height: 156px;
        padding: 0 60px;
        img{
          width: 104px;
          height: 104px;
          border-radius: 50%;
        }
      }
      .h1{
        margin: 42px 0 30px 0;
        text-align: center;
        font-size: 24px;
        color: #BA9E70;
      }
      .data{
        width: 516px;
        height: 176px;
        background-color: rgba(255,255,255,0.7);
        border-radius: 8px;
        margin: 0 auto;
        padding: 22px;
        overflow: hidden;
        .dataImg{
          float: left;
          width: 170px;
          height: 118px;
          display: flex;
          justify-content: center;
          align-items: center;
          img{
            max-width: 100%;
            max-height: 100%;
          }
        }
        .text{
          margin-left: 26px;
          float: left;
          width: 274px;
          .p1{
            height: 80px;
            line-height: 40px;
            font-size: 28px;
            color: #333440;
            margin-bottom: 12px;
            overflow : hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .button{
            width: 160px;
            height: 46px;
            text-align: center;
            line-height: 46px;
            font-size: 24px;
            color: #FFFFFF;
            background-image: linear-gradient(90deg, #EF4B4B 0%, #F7643C 100%);
            box-shadow: 4px 8px 20px 0 rgba(239,75,75,0.27);
            border-radius: 4px;
          }
        }
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/shareSuccessBack.vue